import Vue from "vue";
import Vuex from "vuex";
import { uiStore } from "./ui";

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
  modules: {
    ui: uiStore
  }
});



// WEBPACK FOOTER //
// ./src/app/store.js